import React from 'react';
import InputDateTime from "../../../../components/input/input-datetime.jsx";
import useReportFiltersFetch from "../../../../hooks/use-report-filters-fetch.js";
import InputCheckbox from "../../../../components/input/input-checkbox.jsx";
import SelectComponent from "../../../../components/select/select-component.jsx";
import {minMenuHeight} from "../../../../components/reports/report-menu/menu.jsx";

const Filters = ({ setFilters, filters }) => {
    const { activitiesJournalTeam, activitiesJournalResponsible } = useReportFiltersFetch({fetchActivitiesJournalTeam: true, fetchActivitiesJournalResponsible: true});

    return (
        <>
            <div className={`mb-2 ${minMenuHeight}`}>
                <form className={'space-y-4'}>

                    <InputDateTime
                        id="dtStart"
                        label="Data inicial *"
                        selected={filters.dtStart}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtStart: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <InputDateTime
                        id="dtEnd"
                        label="Data final *"
                        selected={filters.dtEnd}
                        onChange={(date) => setFilters(prev => ({ ...prev, dtEnd: date }))}
                        classNameWrapper={"w-full"}
                        dateFormat="L"
                    />

                    <SelectComponent
                        id="team"
                        label="Equipe"
                        isMulti={true}
                        wrapValues={true}
                        options={activitiesJournalTeam}
                        value={filters.team}
                        onChange={(value) => setFilters(prev => ({ ...prev, team: value }))}
                        classNameWrapper="w-full"
                    />

                    <SelectComponent
                        id="responsible"
                        label="Cadastrado por"
                        isMulti={true}
                        wrapValues={true}
                        options={activitiesJournalResponsible}
                        value={filters.responsible}
                        onChange={(value) => setFilters(prev => ({ ...prev, responsible: value }))}
                        classNameWrapper="w-full"
                    />

                    <div className={"ml-1"}>
                        <InputCheckbox
                            id="showDetails"
                            label="Exibir detalhes"
                            checked={filters.showDetails}
                            onChange={(e) => setFilters(prev => ({...prev, showDetails: e.target.checked}))}
                        />
                    </div>

                </form>
            </div>
        </>
    );
};

export default Filters;